import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'CustomMessageFields' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: null,
    display: null,
    active: { type: Boolean },
    previewTime: null,
    error: { default: '' },
    toggleLabel: { default: 'Show message on this booking slot' },
    hint: { default: 'This text shows in addition to any other text on the customer-facing slot on the booking site.' }
  },
  emits: ["update:message", "update:display", "update:active"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:message', value: string): void
  (e: 'update:display', value: 'text' | 'badge'): void
  (e: 'update:active', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

// Shared editor for the customer-facing custom message on a slot or slot
// template. Parents bind with .sync: :message.sync, :display.sync, :active.sync.




const displayOptions = [
  { value: 'text', label: 'Text' },
  { value: 'badge', label: 'Badge' }
]

return { __sfc: true,emit, displayOptions }
}

})